export default "__VITE_ASSET__CfvNZA2b__"